<div class="custom-sidenav-container" [class.collapsed]="!isSidenavOpen">
  <!-- Toggle Button -->
  <div class="toggle-btn">
    <button type="button" [disabled]="passwordExpiryService.hasPasswordExpired()" (click)="toggleSidenav()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <!-- List of Menu Items -->
  <mat-nav-list>
    @for (item of menuItems; track item) {
      <!-- Single Menu Item -->
      @if (!item.children) {
        <div class="menu-item" [ngClass]="{ collapsed: !isSidenavOpen }">
          <a
            type="button"
            class="menu-btn"
            [disabled]="passwordExpiryService.hasPasswordExpired()"
            [routerLink]="item.link"
            [routerLinkActiveOptions]="{ paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' }"
            mat-button
            routerLinkActive="active"
          >
            <mat-icon class="menu-icon" [matTooltip]="!isSidenavOpen ? (item.name | translate) : ''">
              {{ item.icon }}
            </mat-icon>
            @if (isSidenavOpen) {
              <span class="menu-label-header">{{ item.name | translate }}</span>
            }
          </a>
        </div>
      } @else {
        <!-- Parent Menu -->
        @if (isSidenavOpen) {
          <mat-expansion-panel [class.mat-elevation-z0]="true" [class.active]="isParentLinkActive(item)">
            <mat-expansion-panel-header>
              <div class="title-content">
                <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
                <span class="menu-label">{{ item.name | translate }}</span>
              </div>
            </mat-expansion-panel-header>

            <mat-nav-list class="nav-list">
              @for (child of item.children; track child) {
                <a class="child-list" [routerLink]="child.link" [queryParams]="child.queryParams || {}" [class.active]="isChildLinkActive(child)" mat-list-item>
                  <div class="child-content">
                    <mat-icon class="child-icon light-color">{{ child.icon }}</mat-icon>
                    <span class="child-text">{{ child.name | translate }}</span>
                  </div>
                </a>
              }
            </mat-nav-list>
          </mat-expansion-panel>
        } @else {
          <!-- Collapsed Parent with Dropdown -->
          <div class="menu-item collapsed" [class.active]="isParentLinkActive(item)">
            <button class="menu-btn" [disabled]="passwordExpiryService.hasPasswordExpired()" [matMenuTriggerFor]="menu" mat-button>
              <mat-icon class="menu-icon" matTooltip="{{ item.name | translate }}">{{ item.icon }}</mat-icon>
            </button>

            <mat-menu #menu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
              @for (child of item.children; track child) {
                <a
                  type="button"
                  [disabled]="passwordExpiryService.hasPasswordExpired()"
                  [routerLink]="child.link"
                  [queryParams]="child.queryParams || {}"
                  [class.active]="isChildLinkActive(child)"
                  mat-menu-item
                >
                  <mat-icon class="child-icon">{{ child.icon }}</mat-icon>
                  <span>{{ child.name | translate }}</span>
                </a>
              }
            </mat-menu>
          </div>
        }
      }
    }
  </mat-nav-list>
</div>
